import "./index.scss";
import { useState } from "react";
import { renderDropdownItem } from "./utils/renderDropdownItem";

export const MenuDropdown = ({ items }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleDropdownBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setIsOpen(false);
    }
  };

  const closeDropdown = () => setIsOpen(false);

  return (
    <div
      className={`menu-dropdown ${isOpen ? "open" : "closed"}`}
      onBlur={handleDropdownBlur}
    >
      <button className="trigger-button" onClick={() => setIsOpen(!isOpen)}>
        My Account {isOpen ? "▲" : "▼"}
      </button>
      <div className="menu-list">
        {items.map((item) => renderDropdownItem(item, closeDropdown))}
      </div>
    </div>
  );
};
